module.exports = __webpack_public_path__ + "static/img/34.6bc022f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/34.png
// module id = 4zTy
// module chunks = 0